import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(() => ({
  datePickerWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontWeight: 600,
    padding: ({ direction }: LayoutDirection) => direction === 'rtl' ? `0 0 0 10px` : `0 10px 0 0`,
    lineHeight: '27px',
  },
}));
